import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { useWalletBalanceQuery } from '@/features/dashboard/api/useDashboardQueries';
import { formatMoney } from '@/shared/lib/format/money';

export function DashboardWalletCard() {
  const navigate = useNavigate();
  const { data: walletRes, isLoading } = useWalletBalanceQuery();

  const available = walletRes?.data?.availableBalance ?? 0;

  return (
    <div className="dash-wallet-dark relative flex h-full min-h-[300px] flex-col overflow-hidden rounded-[28px] p-7 text-white shadow-[0_20px_40px_rgba(40,30,110,0.14)]">
      <span className="relative self-start inline-flex items-center gap-1.5 rounded-full bg-white/20 px-3 py-1.5 text-[11px] font-extrabold tracking-[1px] text-white uppercase">
        <span className="h-1.5 w-1.5 rounded-full bg-white" />
        Wallet · Online
      </span>

      <p className="relative mt-[18px] mb-0 text-[13px] text-white/90">
        Available balance
      </p>

      <p className="relative mt-1 mb-0 text-[32px] leading-tight font-extrabold tracking-[-0.02em] sm:text-[38px]">
        {isLoading ? '—' : formatMoney(available)}
      </p>

      <p className="relative mt-2.5 mb-6 flex items-center gap-1.5 text-[13px] text-white/90">
        <Zap size={13} className="shrink-0 text-white" fill="currentColor" />
        Wallet ready — funds can be deployed instantly
      </p>

      <div className="relative mt-auto flex gap-3">
        <button
          type="button"
          onClick={() => navigate('/wallet')}
          className="flex h-[48px] flex-1 items-center justify-center rounded-[14px] border-none bg-white text-[14px] font-bold text-[#2B3E8A] transition hover:bg-white/90 active:scale-[0.99]"
        >
          Add Funds
        </button>
        <button
          type="button"
          onClick={() => navigate('/wallet')}
          className="flex h-[48px] flex-1 items-center justify-center rounded-[14px] border border-white/50 bg-white/20 text-[14px] font-bold text-white transition hover:bg-white/30 active:scale-[0.99]"
        >
          View statement
        </button>
      </div>
    </div>
  );
}
